import React from 'react';
import { Button } from '@alifd/next';
import axios from 'axios';

export default function DownloadExcelModelButton({ func, dbName,text }) {
  const handleDownload = async (db) => {
    const url = `/ezcon/api/getDynamicMenuExcel?type=${db}&demo=yes`;
    const resExcel = await axios.get(url, {
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
      responseType: 'blob',
    });
    const blob = new Blob([resExcel.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${text}_範例.xlsx`;
    link.click();
  };

  return <Button onClick={() => handleDownload(dbName)}>{func.text}</Button>;
}
